import { render, staticRenderFns } from "./CommuneMap.vue?vue&type=template&id=56b5706e&scoped=true&"
import script from "./CommuneMap.vue?vue&type=script&lang=js&"
export * from "./CommuneMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b5706e",
  null
  
)

export default component.exports